import adminAxios from "@/shared/api/adminAxiosInstance";

export const updateUserArrive = ( scheduleId,isArrive, userId) => {
    return adminAxios.put(`/admin/booking/${scheduleId}/users/${userId}/arrive`, {isArrive} );
}

export const getPrivateGamesIds = (requestId) => {
    const params = new URLSearchParams({ isFree: true });

    // передаём ID, если он не null/undefined,
    // даже если это "0" или пустая строка
    if (requestId !== undefined && requestId !== null) {
        params.append('requestId', requestId);
    }

    return adminAxios.get(`/admin/private-game-requests?${params.toString()}`);
};



// выходные по диапазону (на будущее, неделя)
export const getDayOffRange = (params) =>
    adminAxios.get('/admin/calendar/day-off-range', { params });

// занятые слоты
export const getOccupiedSlots = (params) =>
    adminAxios.get('/admin/slots/occupied', { params });

